import _   from '@/lib/lodash-ext'
import app from '@/lib/core/app'
import { deserialise } from 'kitsu-core'

window._   = _
window.app = app
window.deserialise = deserialise
